export const locales = ['fr', 'en', 'es'] as const;
export type Locale = (typeof locales)[number];
export const defaultLocale: Locale = 'fr';

export const localeNames: Record<Locale, string> = {
  fr: 'Français',
  en: 'English',
  es: 'Español',
};

export const localeCurrencies: Record<Locale, string> = {
  fr: 'EUR',
  en: 'EUR',
  es: 'EUR',
};
